// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  margin: 0 -15px;
  border-bottom: 1px solid #e9e9eb;
  cursor: pointer;
  --background-activated: none !important;
  --background-focused: none !important;
  --background-focused-opacity: none !important;
  --background-hover: none !important;
}

::ng-deep ion-input .native-input {
  cursor: pointer;
}

ion-input:active {
  border: none !important;
}

ion-input {
  border: none;
  width: fit-content;
}

ion-popover.small::part(content) {
  min-width: 250px;
}
ion-popover::part(content) {
  min-width: 350px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/elements/date-picker/date-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gCAAA;EACA,eAAA;EACA,uCAAA;EACA,qCAAA;EACA,6CAAA;EACA,mCAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;AACJ;;AAMQ;EACI,gBAAA;AAHZ;AAMI;EACE,gBAAA;AAJN","sourcesContent":["ion-item {\n    margin: 0 -15px;\n    border-bottom: 1px solid #e9e9eb;\n    cursor: pointer;\n    --background-activated: none !important;\n    --background-focused: none !important;\n    --background-focused-opacity: none !important;\n    --background-hover: none !important;\n}\n\n::ng-deep ion-input .native-input {\n    cursor: pointer;\n}\n\nion-input:active {\n    border: none !important;\n}\n\nion-input {\n    border: none;\n    width: fit-content;\n}\n\n\n\nion-popover {\n    &.small {\n        &::part(content) {\n            min-width: 250px;\n        }\n    }\n    &::part(content) {\n      min-width: 350px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
